import React, { memo } from "react";
import Banner from "@modules/Layout/components/CoverBannerCrop";
import { Banner as BannerType } from "@types/common";

interface Props {
  banner: BannerType;
  bg?: string;
}
const Cover: React.FC<Props> = ({ banner, bg }) => {
  return <Banner banner={banner} typeImage={"cover"} bg={bg} />;
};

export default memo(Cover);
